import type {
  CheckInMetricsData,
  CompletedSalesDataByStatus,
  DashboardMetricsResponse,
  DashboardSessionsDto,
  EventParticipantCustomFieldColumnDto,
  ListResponseDto,
  OrdersDataByStatus,
  ProductMetricsResponse,
  ProductWithdrawalMetricsData,
  ReportDownloadDispatchResponse,
  ReportDownloadStatusResponse,
  SessionParticipantDto,
} from '@linka/domain/dtos';
import type { ReportDownloadRequest } from '@linka/domain/requests';
import { httpRequest } from '../client/http';

export const eventDashboardController = {
  dashboardMetrics: httpRequest<unknown, DashboardMetricsResponse>('get', 'event/:eventId/dashboard/overview'),
  detailedOrders: httpRequest<unknown, ListResponseDto<OrdersDataByStatus>>('get', 'event/:eventId/dashboard/orders'),
  detailedCheckins: httpRequest<unknown, ListResponseDto<CheckInMetricsData>>(
    'get',
    'event/:eventId/dashboard/checkins',
  ),
  detailedProductWithdrawals: httpRequest<unknown, ListResponseDto<ProductWithdrawalMetricsData>>(
    'get',
    'event/:eventId/dashboard/product-withdrawals',
  ),
  detailedSales: httpRequest<unknown, ListResponseDto<CompletedSalesDataByStatus>>(
    'get',
    'event/:eventId/dashboard/sales',
  ),
  customFieldColumns: httpRequest<unknown, EventParticipantCustomFieldColumnDto[]>(
    'get',
    'event/:eventId/participant/custom-field-columns',
  ),
  trackingColumns: httpRequest<unknown, string[]>('get', 'event/:eventId/dashboard/tracking-columns'),
  requestDownload: httpRequest<ReportDownloadRequest, ReportDownloadDispatchResponse>(
    'post',
    'event/:eventId/dashboard/reports/download',
  ),
  downloadFile: httpRequest<unknown, Blob>('get', 'event/:eventId/dashboard/reports/download/:exportId/file'),
  downloadStatus: httpRequest<unknown, ReportDownloadStatusResponse>(
    'get',
    'event/:eventId/dashboard/reports/download/:exportId/status',
  ),
  sessionMetrics: httpRequest<unknown, DashboardSessionsDto>('get', 'event/:eventId/dashboard/sessions'),
  sessionParticipants: httpRequest<unknown, { data: SessionParticipantDto[]; total: number }>(
    'get',
    'event/:eventId/dashboard/sessions/participants',
  ),
  productMetrics: httpRequest<unknown, ProductMetricsResponse>('get', 'event/:eventId/dashboard/products'),
};
